import { render, staticRenderFns } from "./CommendReport.vue?vue&type=template&id=bf6cc856&"
import script from "./CommendReport.vue?vue&type=script&lang=js&"
export * from "./CommendReport.vue?vue&type=script&lang=js&"
import style0 from "./CommendReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports